import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { comparerByAlphabet } from '@app/comparers';

import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  ColorActionsUnion,
  ColorActionTypes
} from '@core/actions/color.actions';
import { Color } from '@app/models';

export interface State extends EntityState<Color> {
  loading: boolean;
  loaded: boolean;
  busy: boolean;
  spinnerMessage: string;
  creating: boolean;
}

export const adapter: EntityAdapter<Color> = createEntityAdapter<Color>({
  selectId: (color: Color) => color.id,
  sortComparer: comparerByAlphabet('ASC', 'name')
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  busy: false,
  spinnerMessage: null,
  creating: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: ColorActionsUnion
) {
  switch (action.type) {
    case ColorActionTypes.Load:
      return { ...state, loading: true };

    case ColorActionTypes.LoadFail:
      return { ...state, loading: false };

    case ColorActionTypes.LoadSuccess:
      return adapter.addAll(action.colors,{
        ...state,
        loading: false,
        loaded: true
      });
    case ColorActionTypes.Create:
      return { ...state, creating: true };

    case ColorActionTypes.CreateFail:
    case ColorActionTypes.CreateSuccess:
      return { ...state, creating: false };

    case ColorActionTypes.AddAll:
      return adapter.addAll(action.colors, state);

    case ColorActionTypes.AddOne:
      return adapter.addOne(action.color, state);

    case ColorActionTypes.UpdateOne:
      return adapter.updateOne(
        { id: action.color.id, changes: action.color },
        state
      );

    case ColorActionTypes.ColorProcessUpdate:
      let spinnerMessage = 'Procesando Imagenes...'

      if(action.data && action.data.message){
        spinnerMessage = action.data.message
      }

      return {
        ...state,
        busy: true,
        spinnerMessage
      };

    case ColorActionTypes.UploadProcessSuccess:
      return {
        ...state,
        busy: false,
        spinnerMessage: ''
      };

      case ColorActionTypes.UploadFile:
        return {
          ...state,
          busy: true,
          spinnerMessage: 'Procesando Imagenes'
        }

        case ColorActionTypes.UploadFileSuccess:
        return {
          ...state,
          busy: false,
          spinnerMessage: ''
        }
        
    case ColorActionTypes.DeleteColor:
      return {
        ...state,
        busy: true,
        spinnerMessage: 'Procesando Imagenes'
      }
    
    case ColorActionTypes.DeleteColorSuccess:
      return {
        ...state,
        busy: false,
        spinnerMessage: ''
      }

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;

export const getState = createFeatureSelector<State>('colors');

export const getBusy = createSelector(
  getState,
  (state: State) => state.busy
);

export const getSpinnerMessage = createSelector(
  getState,
  (state: State) => state.spinnerMessage
);

